import React from "react";
import "./HairColorStreaksLandingProgram.css"

const HairColorStreaksLandingProgramHead = () => {
  return (
    <div className="hairColorStreakHeadProgram">
      <h2>Our Programs</h2>
      <p>Make a difference in the life of an individual...</p>
    </div>
  );
};

export default HairColorStreaksLandingProgramHead;
